import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCustomSection,
  getDefaultSection,
} from 'legacyfrontend/redux/actions/custom-section-actions';
import { getSectionDefaultById } from 'legacyfrontend/api/services/endpointSection';
import {
  selectSectionState,
  selectToken,
} from 'legacyfrontend/redux/selectors/application-selectors';

export const useCustomSection = (id, title) => {
  const dispatch = useDispatch();
  const { raw } = useSelector(selectSectionState);
  const token = useSelector(selectToken);
  const [htmlDefault, setHtmlDefault] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDefaultSection = async () => {
    if (!id || !token) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await getSectionDefaultById(id, token);
      setHtmlDefault(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      return;
    }

    if (title === 'Custom') {
      dispatch(getCustomSection(id));
    } else if (title === 'DefaultHtml') {
      dispatch(getDefaultSection(id));
    } else {
      fetchDefaultSection();
    }
  }, [id, title, dispatch, token]);

  const isHtmlContent = raw.tipoSeccion?.nombre !== 'URL';

  // 🔧 CORRECCIÓN: Mejorar la lógica de detección de contenido
  const hasValidContent = () => {
    if (isHtmlContent) {
      // Para contenido HTML, verificar que no esté vacío
      return raw.contenido && raw.contenido.trim() !== '';
    } else {
      // Para URLs, verificar que exista la URL
      return raw.contenido || htmlDefault?.url;
    }
  };

  const hasContent = hasValidContent();
  const sectionExists = raw && Object.keys(raw).length > 0;
  const contentUrl = raw.contenido || htmlDefault?.url;

  return {
    raw,
    htmlDefault,
    isHtmlContent,
    hasContent,
    sectionExists,
    contentUrl,
    isLoading,
    error,
  };
};
